export { Icon } from '@pff-consumer/tweed-ui/atoms/icon/icon.web'
